<template>
    <form class="row g-3" ref="form">
        <div class="col-12">
            <label class="form-label fw-bold">{{ $t("vehicleEntry.carrier") }}</label>
            <Multiselect
                v-if="$store.getters.selectedGatehouse.settings && $store.getters.selectedGatehouse.settings.carrier_multiselect"
                ref="carrierSelect"
                class="multiselect_custom"
                v-model="localVehicle.carrier"
                placeholder=""
                :options="carrierOptions"
                @search-change="getCarriers"
                :searchable="true"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="true"
                :show-no-results="false"
                :taggable="true"
                @tag="addNewCarrier"
                :track-by="null"
                :internal-search="true"
                :preselect-first="true"
                :select-label="$t('multiselect.pressToSelect')"
                :selected-label="$t('multiselect.selected')"
                :deselect-label="$t('multiselect.pressToDeselect')"
                :tagPlaceholder="$t('multiselect.carrier.tagPlaceholder')"
            >
                <template #noOptions>
                    <span>{{ $t("multiselect.carrier.noOptions") }}</span>
                </template>
            </Multiselect>
            <input
                v-else
                type="text"
                class="form-control"
                id="carrier"
                v-model="localVehicle.carrier"
                required
            >
        </div>
        <div class="col-12">
            <label for="name" class="form-label">{{ $t("vehicleEntry.driver_name") }}</label>
            <input type="text" class="form-control" id="name" v-model="localVehicle.driverName">
        </div>
        <div class="col-12">
            <label for="licencePlate" class="form-label fw-bold">{{ $t("vehicleEntry.licencePlate") }}</label>
            <input v-model="localVehicle.licencePlate" type="text" class="form-control" id="licencePlate" required></input>
            <!-- <Multiselect
                class="multiselect_custom"
                v-model="localVehicle.licencePlate"
                required
                placeholder=""
                :options="licencePlateOptions"
                @search-change="getLicencePlates"
                :max="10"
                :searchable="true"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="true"
                :show-no-results="false"
                :taggable="true"
                @tag="addNewLicencePlate"
                :track-by="null"
                :internal-search="true"
                :preselect-first="true"
                :select-label="$t('multiselect.pressToSelect')"
                :selected-label="$t('multiselect.selected')"
                :deselect-label="$t('multiselect.pressToDeselect')"
                :tagPlaceholder="$t('multiselect.tagPlaceholder')"
            >
                <template #noOptions>
                    <span>{{ $t("multiselect.noOptions") }}</span>
                </template>
            </Multiselect> -->
        </div>
        <div class="col-md-6">
            <label for="expectedFrom" class="form-label"><b>{{ $t("vehicleEntry.expectedFrom") }}</b></label>
            <input
                type="datetime-local"
                class="form-control"
                id="expectedFrom"
                v-model="localVehicle.expectedFrom"
                required
                :class="{ 'is-invalid': isInvalidFrom }"
            >
        </div>
        <div class="col-md-6">
            <label for="expectedTo" class="form-label">{{ $t("vehicleEntry.expectedTo") }}</label>
            <input
                type="datetime-local"
                class="form-control"
                id="expectedTo"
                v-model="localVehicle.expectedTo"
                :min="localVehicle.expectedFrom"
                :class="{ 'is-invalid': isInvalidDateRange }"
            >
        <!--
                :min="localVehicle.expectedFrom || today"-->
        </div>
        <div class="col-md-12">
            <label class="form-label fw-bold">{{ $t("status.status") }}</label>
            <div class="d-flex flex-wrap gap-2">
                <div
                    v-for="status in statuses"
                    :key="status.id"
                    class="status-block p-2 me-3 mb-3 mb-md-0 rounded text-center"
                    :class="{ 'selected': localVehicle.status === status.id }"
                    @click="localVehicle.status = status.id"
                >
                    <icon :icon="status.icon" class="status_icon" />
                    <div class="fs-6 fw-bold">{{ $t("status.vehicleEntry." + status.name) }}</div>
                    <input
                        type="radio"
                        class="d-none"
                        :checked="localVehicle.status === status.id"
                    >
                </div>
            </div>
        </div>
        <div class="col-12">
            <label for="note" class="form-label">{{ $t("vehicleEntry.note") }}</label>
            <textarea class="form-control mb-3" id="note" v-model="localVehicle.note"></textarea>
        </div>
    </form>
</template>

<script>
    import Icon from '@/components/Icon.vue'
    import { formatDatetimeLocal } from '@/utils/date';
    import Multiselect from 'vue-multiselect'

    export default {
        components: {
            Icon,
            Multiselect
        },
        props: {
            vehicle: {
                type: Object,
                default: () => ({})
            },
        },
        data() {
            return {
                localVehicle: {...this.vehicle},
                statuses: [],
                licencePlateOptions: [],
                carrierOptions: [],
            }
        },
        created() {
            this.getStatuses();
        },
        methods: {
            validateData() {
                if (!this.localVehicle.carrier && this.$refs.carrierSelect) {
                    this.$refs.carrierSelect.$el.scrollIntoView({ behavior: "smooth", block: "center" });
                    this.$refs.carrierSelect.$el.querySelector("input").focus();
                    return false;
                }
                if (this.$refs.form.checkValidity() === false){
                    this.$refs.form.reportValidity();
                    return false;
                }
                return true;
            },
            submitForm() {
            if (!this.validateData()) return;
                return this.localVehicle;
            },
            getStatuses() {
                this.$store.getters.api.get(`/${this.$route.params.slug}/statuses?model=vehicleentry`)
                .then(response => {
                    this.statuses = response.data;

                    if (!this.localVehicle.status) {
                        const reserved = this.statuses.find(s => s.name === "reserved");
                        if (reserved) {
                            this.localVehicle.status = reserved.id;
                        }
                    }
                })
                .catch(error => {
                    console.error("Error loading statuses", error);
                });
            },

            getLicencePlates(query) {
                if (!query || query.length < 2) return;

                this.$store.getters.api.get(`/${this.$route.params.slug}/vehicle-entries/licence-plates?q=${query}`)
                    .then(response => {
                        this.licencePlateOptions = response.data;
                    })
                    .catch(err => {
                        console.error("Error fetching licence plates", err);
                    });
            },
            addNewLicencePlate(newPlate) {
                if (!this.licencePlateOptions.includes(newPlate)) {
                    this.licencePlateOptions.push(newPlate);
                }
                this.localVehicle.licencePlate = newPlate;
            },
            getCarriers(query) {
                if (!query || query.length < 2) return;

                this.$store.getters.api.get(`/${this.$route.params.slug}/vehicle-entries/carriers?q=${query}`)
                    .then(response => {
                        this.carrierOptions = response.data;
                    })
                    .catch(err => {
                        console.error("Error fetching carriers", err);
                    });
            },
            addNewCarrier(newCarrier) {
                if (!this.carrierOptions.includes(newCarrier)) {
                    this.carrierOptions.push(newCarrier);
                }
                this.localVehicle.carrier = newCarrier;
            },
        },
        computed: {
            today() {
                const now = new Date();
                now.setSeconds(0);
                now.setMilliseconds(0);
                return now.toISOString().slice(0, 16);
            },
            isInvalidFrom() {
                if (!this.localVehicle.expectedFrom) return false;

                return this.localVehicle.expectedFrom < this.today;
            },
            isInvalidDateRange() {
                const from = new Date(this.localVehicle.expectedFrom);
                const to = new Date(this.localVehicle.expectedTo);
                return this.localVehicle.expectedFrom && this.localVehicle.expectedTo && to <= from;
            }
        },
        watch: {
            vehicle: {
                handler(newVal) {
                    this.localVehicle = {
                        carrier: newVal.carrier || "",
                        driverName: newVal.driver_name || "",
                        licencePlate: newVal.licence_plate || "",
                        expectedFrom: formatDatetimeLocal(newVal.expected_from),
                        expectedTo: formatDatetimeLocal(newVal.expected_to),
                        status: newVal.status || "",
                        note: newVal.note || ""
                    };

                    if (!this.localVehicle.status && this.statuses.length) {
                        const reserved = this.statuses.find(s => s.name === "reserved");
                        if (reserved) {
                            this.localVehicle.status = reserved.id;
                        }
                    }
                },
                immediate: true
            },
            "localVehicle.expectedFrom"(newVal) {
                if (!newVal) return;

                const from = new Date(newVal);
                const to = new Date(from.getTime() + 30 * 60 * 1000);

                this.localVehicle.expectedTo = formatDatetimeLocal(to);
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/scss/abstracts/variables";
    @import "@/scss/base/typography.scss";

    .status_icon {
        width: 40px;
        height: 40px;
    }
</style>